// extracted by mini-css-extract-plugin
export default {"expandableTextDisplay":"CrExpandableTextDisplay_expandableTextDisplay__3JfuO"};